// extracted by mini-css-extract-plugin
module.exports = {"disabled":"style-module_disabled__SID4iB-28GbWdJ-GJj8st"};